module.exports = __webpack_public_path__ + "eb58785a31fde69d4013cfd495e90238.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupon-modal-bg.png
// module id = 1253
// module chunks = 61